module.exports = __webpack_public_path__ + "img/delete_icon.ce8e2a41.svg";